const messages = {
  filtersApplied: (countAppliedFilters) =>
    `Filters Applied: (${countAppliedFilters})`,
  clearAll: 'Clear All',
  yourSelections: 'Your Selections',
}

export default messages
